module.exports = __webpack_public_path__ + "img/mid-section-mobile.1532603b.jpg";